import { render, staticRenderFns } from "./Temoignages.vue?vue&type=template&id=ca6b8a88&scoped=true&"
import script from "./Temoignages.vue?vue&type=script&lang=js&"
export * from "./Temoignages.vue?vue&type=script&lang=js&"
import style0 from "./Temoignages.vue?vue&type=style&index=0&id=ca6b8a88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca6b8a88",
  null
  
)

export default component.exports